<template>
  <el-dialog v-bind="$attrs"> <slot /> </el-dialog>
</template>

<script>
export default {
  name: 'RtDialog'
};
</script>

<style></style>



// WEBPACK FOOTER //
// rtDialog.vue?0e91fcb6